import React from 'react';
import styled from "styled-components";

const Title = styled.div`
    font-family: 'Sora', cursive;
    font-size: ${props => props.theme.fontxxl};
    text-transform: capitalize;
    width: 80%;
    font-weight: 900;
    color: ${props => props.theme.text};
    align-self: flex-start;
    span{
        text-transform: uppercase;
        font-family: 'Akaya Telivigala', cursive;

    }
    .text-1{
        color: blue;
    }
    .text-2{
        color: orange;
    }
    .text-3{
        color: red;
    }

    @media (max-width: 70em) {
        font-size: ${(props) => props.theme.fontxl};
    }

    @media (max-width: 48em) {
        align-self: center;
        text-align: center;
    }
`
const SubTitle = styled.h3`
    font-size: ${props => props.theme.fontlg};
    text-transform: uppercase;
    color: ${props => `rgba(${props.theme.textRgba}, 0.6)`};
    font-weight: 600;
    margin: 1rem 0;
    width: 80%;
    align-self: flex-start;

    @media (max-width: 40em) {
        font-size: ${(props) => props.theme.fontmd};
    }

    @media (max-width: 48em) {
        align-self: center;
        text-align: center;
    }
`

const ButtonContainer = styled.div`
    width: 80%;
    align-self: flex-start;

    @media (max-width: 48em) {
        width: 100%;
        text-align: center;
    }
`

const Button = styled.button`
    background: ${props => props.theme.text};
    color: ${props => props.theme.body};
    padding: 0.6rem 1.5rem; 
    border-radius: 0.3rem;
    cursor: pointer;
    font-size: ${props => props.theme.fontButton}
`

const TypeWriterText = () => {
    return (
        <>
            <Title>
                Digital art is the trend today Welcome to the world of "NFTs"
            </Title>
            <SubTitle>Create, explore &amp; collect digital art nfts</SubTitle>
            <ButtonContainer><Button>Explore</Button></ButtonContainer>
        </>

    )
}
export default TypeWriterText;